export default __webpack_public_path__ + "static/media/splashScreen.24a2ec99.png";